import React from "react";
import ResidualVolumeChart from "./ResidualVolumeChart";
import ResidualScoreCard from "./ResidualScoreCard";
import styles from "./style.module.scss";

const ResidualCharts = () => {
  return (
    <div className={styles.charts_container}>
      <div className={styles.chart_card}>
        <div className={styles.volumeChartHeader}>
          <h5>Residuals volume</h5>
        </div>
        <div className={styles.chart}>
          <ResidualVolumeChart />
        </div>
      </div>
      <ResidualScoreCard />
    </div>
  );
};

export default ResidualCharts;